const isAriaHiddenTrue = ($el) => {
  const ariaHiddenValue = $el ? $el.getAttribute("aria-hidden") : null;
  return ariaHiddenValue === "true";
};

const isHTMLElement = (node) => {
  return node.nodeType === Node.ELEMENT_NODE;
};

const isModal = (node) => {
  if (node.children.length !== 1) return false;
  const modalContainer = Array.from(node.children[0].classList).some((cls) =>
    cls.startsWith("kl-private-reset"),
  );

  return modalContainer;
};

const getTopLevelDomElements = () => {
  const body = document.body;

  // Use the children property to get all top-level elements
  const topLevelNodes = Array.from(body.children).filter((node) => {
    if (isHTMLElement(node)) {
      const tagName = node.tagName.toLowerCase();

      // Filter out specific tags
      return (
        tagName !== "script" &&
        tagName !== "link" &&
        tagName !== "iframe" &&
        tagName !== "style" &&
        !isModal(node)
      );
    }
    return false;
  });

  return topLevelNodes;
};

const a11yHideTopLevelElements = () => {
  const $elements = getTopLevelDomElements();

  $elements.forEach(($el) => {
    if (!isAriaHiddenTrue($el)) {
      $el.setAttribute("kl-aria-hidden", "true");
      $el.setAttribute("aria-hidden", "true");
    }
  });
};

const a11yShowTopLevelElements = () => {
  const $elements = getTopLevelDomElements();

  $elements.forEach(($el) => {
    if ($el.hasAttribute("kl-aria-hidden")) {
      $el.removeAttribute("kl-aria-hidden");
      $el.removeAttribute("aria-hidden");
    }
  });
};

window.addEventListener("klaviyoForms", function (e) {
  if (e.detail.type == "open") {
    a11yHideTopLevelElements();
  }
  if (e.detail.type == "close") {
    a11yShowTopLevelElements();
  }
});
